import React, { useEffect, useState } from "react";
import DiagnosisSlider from "../../molecules/diagnosis-slider/DiagnosisSlider";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import TypeDiagnosisQuestion from "../../organism/type-diagnosis-question/TypeDiagnosisQuestion";
import { diagnosisQuestionList } from "./question.const";
import headerImage from "../../static/images/typeDiagnosis/DiagnosisQuestionHeader.svg";
import classes from "./TypeDiagnosisContents.module.scss";
import {
  DiagnosisPostRequestType,
  postDiagnosis,
} from "../../api/UsersDiagnosisApi";
import DiagnosisLoading from "../../organism/diagnosis-loading/DiagnosisLoading";
import { useNavigate } from "react-router-dom";

const TypeDiagnosisContents = () => {
  const navigate = useNavigate();
  const [diagnosisParam, setDiagnosisParam] =
    useState<DiagnosisPostRequestType>({});
  const [currentQuiz, setCurrentQuiz] = useState(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const postDiagnosisApi = postDiagnosis();

  const answerCallback = (questionNo: number, answerNo: number) => {
    const newParam = { ...diagnosisParam, [questionNo.toString()]: answerNo };
    setDiagnosisParam(newParam);

    if (questionNo === diagnosisQuestionList.length) {
      // 最後の質問に答えたら登録処理へ
      submitCallbackRegistered(newParam);
    } else {
      setCurrentQuiz(questionNo + 1);
    }
  };

  const prevCallback = (questionNo: number) => {
    if (questionNo <= 1) return;
    setCurrentQuiz(questionNo - 1);
  };

  const submitCallbackRegistered = (param: DiagnosisPostRequestType) => {
    setIsLoading(true);
    postDiagnosisApi.post({ answers: param });
  };

  // ローディング後の画面遷移
  useEffect(() => {
    if (!isLoading) return;
    if (postDiagnosisApi.state?.data == null) return;
    setTimeout(() => {
      setIsLoading(false);
      navigate("/type9-diagnosis-result");
    }, 5000);
  }, [postDiagnosisApi, isLoading, navigate]);

  return (
    <>
      {isLoading ? (
        <DiagnosisLoading />
      ) : (
        <>
          <img src={headerImage} className={classes.headerImage} />
          <div className={classes.content}>
            <DiagnosisSlider
              currentNo={currentQuiz}
              totalNo={diagnosisQuestionList.length}
            />
            <TypeDiagnosisQuestion
              answerCallback={answerCallback}
              prevCallback={prevCallback}
              content={diagnosisQuestionList[currentQuiz - 1]}
              hidePrev={currentQuiz === 1}
              selectedNo={diagnosisParam?.[currentQuiz]}
            />
          </div>
          <BreadCrumb
            data={[
              { displayName: "みらいいコンシェル", url: "/top" },
              { displayName: "子育てとおカネの9タイプ診断" },
            ]}
          />
        </>
      )}
    </>
  );
};

export default TypeDiagnosisContents;
